import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

//defines which balance is used for which masses.
const getMeasuredUsingConfig = (prefix: string) => {
  const constantDryMassPrefix = `${prefix}.Masses.MeasuredWashedConstantDryMass`;
  const balance = wrap(`${constantDryMassPrefix}.Equipment.Balance`);
  const dryBalance = wrap(`${constantDryMassPrefix}.Equipment.DryMassBalance`);

  return {
    [`${constantDryMassPrefix}.DryingTray.ContainerMass`]: balance,
    [`${constantDryMassPrefix}.DryingTray.WetSoilAndContainerMass`]: balance,
    [`${constantDryMassPrefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: dryBalance,
  };
};

export default getMeasuredUsingConfig;
